import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {ArenaGameFiltersCategoryEditor} from "../../arena-filters/categories/arena-game-filters-category-editor";
import {IAdvancedStrategyFiltersEditorViewModel} from "./advanced-strategy-filters-editor-view-model.interface";
import {IArenaGameFiltersCategory} from "../../arena-filters/categories/arena-game-filters-category.interface";

export class AdvancedStrategyFiltersEditor implements IAdvancedStrategyFiltersEditorViewModel {
    constructor(private readonly filtersCategories: IArenaGameFiltersCategory[],
                private readonly services: IServiceFactoryExtended) {

        this._categories = this.filtersCategories.map(c => new ArenaGameFiltersCategoryEditor(c));
    }

    private _categories: ArenaGameFiltersCategoryEditor[];
    get visibleCategories(): ArenaGameFiltersCategoryEditor[] {
        return this._categories.filter(c => c.visibleFilters.length > 0);
    }

    private _getAppliedFiltersIds(): string[] {
        let result: string[] = [];

        this._categories.forEach(c => {
            result = [
                ...result,
                ...c.getAppliedFiltersIds()
            ];

        });
        return result;
    }

    async applyFilters(): Promise<void> {
        await this.services.gamesFilter.applyFilters(this._getAppliedFiltersIds());
    }
}